<div class="cargo-information-container">
    <div>

        <h1>Информация о грузе</h1>

        <div class="container">
            <div class="container__item align-items--flex-end_el-form-item__content container__item--order--1">
                <el-form-item>
                    <el-col :span="11">
                        <el-form-item label="Вид груза" prop="cargoInformation.typeOfCargo">
                            <el-select v-model="dataForm.cargoInformation.typeOfCargo" placeholder="Выберите вариант">
                                <el-option v-for="type in typeOfCargos" :key="type.value" :label="type.label"
                                           :value="type.value"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2"/>
                    <el-col :span="11">
                        <el-form-item label="Количество мест" prop="cargoInformation.numberOfIdenticalLoads">
                            <el-input v-model="dataForm.cargoInformation.numberOfIdenticalLoads" min="1" type="number"
                                      class="hidden_el-input-group__append" @change="checkNumberOfIdenticalLoads">
                                <template #append>шт.</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-form-item>
            </div>
            <div class="container__item align-items--flex-end_el-form-item__content container__item--order--0">
                <template v-if="dataForm.cargoInformation.typeOfCargo !== 'Шины'">
                    <el-form-item v-if="dataForm.cargoInformation.typeOfCargo === 'Цилиндры'" label="Габариты груза" prop="cargoInformation.cargoDimensions">
                        <template #label>Габариты груза<span class="hidden-pc">, см</span></template>
                        <el-col :span="6">
                            <el-form-item>
                                <el-input
                                        type="number"
                                        placeholder="В"
                                        v-model="dataForm.cargoInformation.sizeOfCargoCylinder.height"
                                        min="0"
                                        class="hidden_el-input-group__append"
                                        @change="(value) => {checkValidityDimension(value, 'height');calculateVolume('sizeOfCargoCylinder.height')}"
                                >
                                    <template #append>см</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" class="multiplication">х</el-col>
                        <el-col :span="6">
                            <el-form-item>
                                <el-input
                                        type="number"
                                        placeholder="Д"
                                        v-model="dataForm.cargoInformation.sizeOfCargoCylinder.diameter"
                                        min="0"
                                        class="hidden_el-input-group__append"
                                        @change="(value) => {checkValidityDimension(value, 'size');calculateVolume('sizeOfCargoCylinder.diameter')}"
                                >
                                    <template #append>см</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>

                    <el-form-item v-else label="Габариты груза" prop="cargoInformation.cargoDimensions">
                        <template #label>Габариты груза<span class="hidden-pc">, см</span></template>
                        <el-col :span="6">
                            <el-form-item prop="cargoInformation.length">
                                <el-input
                                        type="number"
                                        placeholder="Д"
                                        v-model="dataForm.cargoInformation.cargoDimensions.length"
                                        min="10"
                                        class="hidden_el-input-group__append"
                                        @change="(value) => {checkValidityDimension(value, 'size');calculateVolume('cargoDimensions.length')}"
                                >
                                    <template #append>см</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" class="multiplication">х</el-col>
                        <el-col :span="6">
                            <el-form-item >
                                <el-input
                                        type="number"
                                        placeholder="Ш"
                                        v-model="dataForm.cargoInformation.cargoDimensions.width"
                                        min="10"
                                        class="hidden_el-input-group__append"
                                        @change="(value) => {checkValidityDimension(value, 'size');calculateVolume('cargoDimensions.width')}"
                                >
                                    <template #append>см</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" class="multiplication">х</el-col>
                        <el-col :span="6">
                            <el-form-item>
                                <el-input
                                        type="number"
                                        placeholder="В"
                                        v-model="dataForm.cargoInformation.cargoDimensions.height"
                                        min="10"
                                        class="hidden_el-input-group__append"
                                        @change="(value) => {checkValidityDimension(value, 'height');calculateVolume('cargoDimensions.height');}"
                                >
                                    <template #append>см</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </template>
            </div>
            <div class="container__item align-items--flex-end_el-form-item__content container__item--order--3">
                <el-form-item label="Объявленная стоимость груза" prop="cargoInformation.cargoCost">
                    <el-input
                            type="number"
                            v-model="dataForm.cargoInformation.cargoCost"
                            min="0"
                            @change="checkCargoCost"
                    />
                    <div class="total-weight--error" v-if="(dataForm.cargoInformation.cargoCost >= 30000)">
                        Обрешетка может быть обязательной - в зависимости от <a target="_blank"
                                                                                href="https://xn----stbeziy.xn--p1ai/dlya-klienta/udorozhanie">характера груза</a>
                    </div>
                </el-form-item>
            </div>
            <div class="container__item align-items--flex-end_el-form-item__content container__item--order--2 align-items--flex-start">
                <el-form-item class="" v-if="dataForm.cargoInformation.typeOfCargo !== 'Шины'">
                    <el-col :span="11">
                        <el-form-item label="Общая масса" prop="cargoInformation.cargoWeight">
                            <template #label>Общая масса<span class="hidden-pc">, кг</span></template>
                            <el-input
                                    type="number"
                                    v-model="dataForm.cargoInformation.cargoWeight"
                                    min="0"
                                    class="totalWeight hidden_el-input-group__append"
                                    @change="(value) => {checkValidityDimension(value, 'weight');handlerWeight(value);}"
                            >
                                <template #append>кг</template>
                            </el-input>
                            <div class="total-weight--error"
                                 v-if="checkDayToDay(dataForm.applicationCargoPickup.pickupDate) && checkCity()">
                                День в день до
                                <span v-if="!checkHour()">12:00, больше</span>
                                <span v-else>15:00, меньше</span>
                                30кг
                            </div>
                            <!-- <div class="total-weight--error">День в день до 12:00, больше 30кг</div> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="2"/>
                    <el-col :span="11">
                        <el-form-item v-if="dataForm.cargoInformation.typeOfCargo !== 'Цилиндры'" label="Общий объём">
                            <template #label>Общий объём<span class="hidden-pc">, м&#179</span></template>
                            <el-col :span="20">
                                {{ dataForm.cargoInformation.cargoVolume }}
                            </el-col>
                            <el-col :span="1"/>
                            <el-col :span="3">
                                м&#179
                            </el-col>
                            <!-- <el-input
                              type="number"
                              v-model="dataForm.cargoInformation.cargoVolume"
                              min="0"
                              class="hidden_el-input-group__append"
                              @change="calculateDimensions('cargoVolume')"
                            >
                              <template #append>м&#179</template>
                            </el-input> -->
                        </el-form-item>
                    </el-col>
                </el-form-item>
            </div>
        </div>


        <div class="container">
            <div class="container__item">

                <el-form-item class="align-items--flex-end_el-form-item__content">
                    <el-col :span="11">
                        <el-form-item>
                            <el-switch
                                    v-model="dataForm.cargoInformation.additionalPackaging"
                                    active-text="Доп. упаковка"
                                    @change="toggleTypePackaging"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="2"/>
                    <el-col :span="11">
                        <el-form-item
                                class="cargo-information-container__type-of-packaging"
                                label="Тип упаковки"
                                prop="cargoInformation.typeOfPackaging"
                        >
                            <el-select
                                    v-model="dataForm.cargoInformation.typeOfPackaging"
                                    placeholder="Выберите вариант"
                                    multiple
                                    collapse-tags
                                    collapse-tags-tooltip
                                    @change="checkPackageType"
                                    :disabled="!dataForm.cargoInformation.additionalPackaging"
                            >
                                <el-option
                                        v-for="type in typeOfPackagings"
                                        :key="type.value"
                                        :label="type.label"
                                        :value="type.value"
                                        :disabled="checkIntersectionsTypes(type.disabled, type.label)"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
            </div>

            <div class="container__item">
                <el-form-item>
                    <el-col :span="24">
                        <el-form-item label="Характер груза" prop="cargoInformation.natureOfCargo">
                            <el-input v-model="dataForm.cargoInformation.natureOfCargo" type="textarea"/>
                        </el-form-item>
                    </el-col>
                </el-form-item>
            </div>
        </div>
    </div>

    <div class="bord_button">
        <el-form-item>
            <el-button
                    class="button_send"
                    type="primary"
                    @click="$emit('click-button-back')">
                Назад
            </el-button>
        </el-form-item>
        <el-form-item>
            <el-button
                    class="button_send"
                    type="primary"
                    @click="$emit('click-button-next', [...getArrayOfRules(dataForm.cargoInformation, 'cargoInformation')])">
                Далее
            </el-button>
        </el-form-item>
    </div>

    <el-dialog
        v-model="dialogBadDimensionsInfo.open"
        title="Уважаемый клиент!"
        class="dialog"
        center
    >
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 8px;">
        <div>
            Максимально допустимые габариты для городов превышены.
        </div>
        <div class="dialogContent_wrapper">
            <div v-if="cityFromRestrictions">
                <div style="font-size: 1rem;">{{cityFromRestrictions.name}}:</div>
                <div :class="{redText: cityFromRestrictions.maxAcceptedShippingHeight === dialogBadDimensionsInfo.maxHeight}">
                    -Макс. высота: {{cityFromRestrictions.maxAcceptedShippingHeight / 100}} м.
                </div>
                <div :class="{redText: cityFromRestrictions.maxAcceptedShippingWeight === dialogBadDimensionsInfo.maxWeight}">
                    -Макс. вес: {{cityFromRestrictions.maxAcceptedShippingWeight}} кг.
                </div>
                <div :class="{redText: cityFromRestrictions.maxAcceptedShippingSize === dialogBadDimensionsInfo.maxSize}">
                    -Макс. длина/ширина: {{cityFromRestrictions.maxAcceptedShippingSize / 100}} м.
                </div>
            </div>
            <div v-if="cityToRestrictions">
                <div style="font-size: 1rem;">{{cityToRestrictions.name}}:</div>
                <div :class="{redText: cityToRestrictions.maxAcceptedHeight === dialogBadDimensionsInfo.maxHeight}">
                    -Макс. высота: {{cityToRestrictions.maxAcceptedHeight / 100}} м.
                </div>
                <div :class="{redText: cityToRestrictions.maxAcceptedWeight === dialogBadDimensionsInfo.maxWeight}">
                    -Макс. вес: {{cityToRestrictions.maxAcceptedWeight}} кг.
                </div>
                <div :class="{redText: cityToRestrictions.maxAcceptedSize === dialogBadDimensionsInfo.maxSize}">
                    -Макс. длина/ширина: {{cityToRestrictions.maxAcceptedSize / 100}} м.
                </div>
            </div>
        </div>
        <div>Свяжитесь, пожалуйста, с менеджером по телефону:</div>
        <div style="margin-top: '15px';">
            <a style="color: #0000EE; text-decoration: underline;" href="tel:89222382000">89222382000</a>
        </div>
        <div>Или по email:</div>
        <div style="margin-top: '15px';">
            <a style="color: #0000EE; text-decoration: underline;" href="mailto:logist@tk-luch.ru">logist@tk-luch.ru</a>
        </div>
    </div>
</el-dialog>

</div>